// src/utils/timeUtils.js (pastikan semua fungsi diexport)
import { format, formatDistanceToNow, isToday, isTomorrow, isYesterday } from 'date-fns';
import { id as localeID } from 'date-fns/locale';

let timezoneCache = null;

export const getUserTimezone = () => {
  if (!timezoneCache) {
    timezoneCache = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  return timezoneCache;
};

export const formatMatchTime = (match) => {
  const matchDateTime = new Date(match.dateISO);
  
  return {
    localTime: format(matchDateTime, 'HH:mm', { locale: localeID }),
    localDate: format(matchDateTime, 'EEEE, dd MMM yyyy', { locale: localeID }),
    relativeTime: formatDistanceToNow(matchDateTime, { addSuffix: true, locale: localeID }),
    isToday: isToday(matchDateTime),
    isTomorrow: isTomorrow(matchDateTime),
    isYesterday: isYesterday(matchDateTime),
    timestamp: matchDateTime.getTime(),
    timezone: getUserTimezone(),
    utcTime: matchDateTime.toISOString()
  };
};

export const shouldShowMatch = (match) => {
  if (!match.showStart || !match.showEnd) return true;
  
  const now = new Date().getTime();
  const showStart = new Date(match.showStart).getTime();
  const showEnd = new Date(match.showEnd).getTime();
  
  return now >= showStart && now < showEnd;
};

export const getMatchStatus = (match) => {
  const now = new Date().getTime();
  const matchTime = new Date(match.dateISO).getTime();
  const matchEndTime = matchTime + (2 * 60 * 60 * 1000); // +2 jam
  
  if (now >= matchTime && now < matchEndTime) {
    return 'live';
  } else if (now >= matchEndTime) {
    return 'finished';
  } else {
    return 'upcoming';
  }
};

export const getTimeRemaining = (match) => {
  const now = new Date().getTime();
  const matchTime = new Date(match.dateISO).getTime();
  const diff = matchTime - now;
  
  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isLive: true };
  }
  
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  
  return { days, hours, minutes, seconds, isLive: false };
};

// TAMBAHKAN FUNGSI INI - untuk format waktu lokal
export const formatLocalTime = (isoString) => {
  if (!isoString) return '-';
  const date = new Date(isoString);
  return format(date, 'HH:mm', { locale: localeID });
};

export const formatLocalDate = (isoString) => {
  if (!isoString) return '-';
  const date = new Date(isoString);
  return format(date, 'EEEE, dd MMM yyyy', { locale: localeID });
};

// Fungsi konversi WIB ke UTC (opsional)
export const wibToUTC = (dateStr, timeStr) => {
  const [year, month, day] = dateStr.split('-').map(Number);
  const [hour, minute] = timeStr.split(':').map(Number);
  const utcDate = new Date(Date.UTC(year, month - 1, day, hour - 7, minute, 0));
  return utcDate.toISOString();
};